import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/page";
import ShoppingGuidePage from "../pages/shopping-guide/page";
import ComparisonPage from "../pages/cssbuy-vs-kakobuy/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/cssbuy-spreadsheet-complete-guide",
    element: <ArticlePage />,
  },
  {
    path: "/shopping-guide",
    element: <ShoppingGuidePage />,
  },
  {
    path: "/cssbuy-vs-kakobuy-spreadsheet",
    element: <ComparisonPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;